/* Version: 3.5.155 */
'use client';
var DROPDOWN_VARIANT = {
  BASIC: 'basic',
  BASIC_LINE: 'basic_line',
  BASIC_LINE_DASHED: 'basic_line_dashed'
};

export { DROPDOWN_VARIANT };
